import classNames from 'classnames'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { format } from 'currency-formatter'
import { Card } from './Card'

import styles from './Cards.module.scss'

interface CardsProps {
  title: React.ReactNode
  count: number
  total?: number
  className?: string
  classes?: {
    card?: string
    total?: string
  }
}

export const Cards: React.FC<CardsProps> = ({
  title,
  count,
  total,
  className,
  classes,
}) => {
  const value = format(count, { thousand: '.', precision: 0 })
  const percentage = total && Math.round((count / total) * 100)
  return (
    <Row className={classNames(className, 'align-content-center mx-0')}>
      <Card
        cardClassName={classNames(
          styles.cardTotal,
          classes?.card || styles.default
        )}
      >
        <div className={styles.content}>{title}</div>
        <Row
          noGutters
          className={classNames(
            styles.total,
            'd-flex align-items-end',
            classes?.total
          )}
        >
          <Col xs="auto">{value}</Col>
          {!!percentage && (
            <Col className="ml-2">
              <small className={classNames(styles.small)}>
                ({percentage}%)
              </small>
            </Col>
          )}
        </Row>
      </Card>
    </Row>
  )
}

export default Cards
